<template>
    <div :class="color" class="text-none subtitle-2">
        {{ text }}
    </div>
</template>

<script>
export default {
    name: "DotStatus",
    props: {
        leftDot: {
            type: Boolean
        },
        text: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: "black"
        }
    }
};
</script>
